import { z } from 'zod';

export const authRegistrationInputSchema = z.object({
  deviceId: z.string(),
});

export const generateAuthInputSchema = z.object({
  username: z.string(),
  deviceId: z.string(),
});

export const verifyAuthInputSchema = z.object({
  username: z.string(),
  deviceId: z.string(),
  params: z.record(z.string(), z.any()),
});

export const userPinLength = 6;

const userPinValueSchema = z
  .string()
  .regex(RegExp(`\\d{${userPinLength}}`), `PIN must be ${userPinLength} digits`);

export const newUserPinSchema = z
  .object({
    value: userPinValueSchema,
    repeatValue: userPinValueSchema,
  })
  .refine(({ value, repeatValue }) => value === repeatValue, {
    message: 'Entered PINs do not match',
    path: ['repeatValue'],
  });

export const verifyUserPinAuthInputSchema = z.object({
  username: z.string(),
  value: userPinValueSchema,
});

export const getUserPinFailedAttemptCountInputSchema = z.object({
  username: z.string(),
});

export const deleteUserPinInputSchema = z.object({
  username: z.string(),
});
